module.exports = "/_next/static/images/13-1-3180dc8cd931900d1eaa1022fe8caeae.svg";